import { NgModule } from '@angular/core';
import { S124gS124m01Component } from './s124g-s124m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S124gS124m01Component]
})
export class S124gModule { }

